import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { outputMaskOptions } from 'utils/proxy/proxyConstants'
import { selectProxyCheckerLoading } from 'store/service/selectors'

import styles from '../../../Products.module.scss'

import InputGroup from 'components/elements/forms/InputGroup'
import CopyButton from 'components/elements/buttons/CopyButton'
import ResultBlock from 'components/elements/blocks/ResultBlock'
import CustomSelect from 'components/elements/inputs/CustomSelect'
import CustomButton from 'components/elements/buttons/CustomButton'
import { ISelectOption } from 'components/elements/inputs/CustomSelect/CustomSelect'

interface IUrlResultProps {
  result: string
  activeSessionLengthType: any
  selectedOutputMask: ISelectOption
  onOutputMaskChange: (option: ISelectOption) => void
  onGenerateIpClick: () => void
  onCheckProxyConnection: () => void
}

const UrlResult: React.FC<IUrlResultProps> = (props) => {
  const {
    result,
    selectedOutputMask,
    activeSessionLengthType,
    onOutputMaskChange,
    onGenerateIpClick,
    onCheckProxyConnection,
  } = props

  const proxyCheckerLoading = useSelector(selectProxyCheckerLoading)

  const [gettingNewIpLoaderStatus, toggleGettingNewIpLoader] = useState(false)

  const handleOutputMaskChange = (option: any) => {
    onOutputMaskChange(option)
  }

  const handleGenerateIp = () => {
    toggleGettingNewIpLoader(true)
    setTimeout(() => toggleGettingNewIpLoader(false), 300)

    onGenerateIpClick()
  }

  const handleCheckProxy = () => {
    onCheckProxyConnection()
  }

  return (
    <div>
      <div className={styles.resultNotice}>
        Choose if your software accepts proxy details as a URL.
      </div>

      <InputGroup
        labelTop={'Output mask'}
        className={styles.outputMaskBlock}
        boldLabel
      >
        <CustomSelect
          onChange={handleOutputMaskChange}
          value={selectedOutputMask}
          name={'url-result-output-mask'}
          isSearchable={false}
          options={outputMaskOptions}
        />
      </InputGroup>

      <div className={styles.controls}>
        <CopyButton className={styles.rowBtn} size={'m'} text={result}>
          Copy URL
        </CopyButton>

        <CustomButton
          className={styles.rowBtn}
          color={'outline'}
          onClick={handleGenerateIp}
          loading={gettingNewIpLoaderStatus}
          disabled={activeSessionLengthType === 'new'}
        >
          Get new IP
        </CustomButton>

        <CustomButton
          className={styles.rowBtn}
          color={'outline'}
          loading={proxyCheckerLoading}
          onClick={handleCheckProxy}
        >
          Check proxy connection
        </CustomButton>
      </div>

      <ResultBlock className={styles.resultBlock}>{result}</ResultBlock>
    </div>
  )
}

export default UrlResult
